import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { useForm, Controller, Feedback } from 'react-hook-form';
import Spinner from 'react-bootstrap/Spinner';

import { useHistory, NavLink, useLocation } from 'react-router-dom';
import logo from '../../../asses/img/parkingl.png'
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import axios from 'axios';
import { FaHome } from 'react-icons/fa';
import { URL_EMPLOYEE } from '../../../constans/servidor';


import BuscadorComponen from '../../../components/Desenganche/Buscador'
import TableComponent from '../../../components/Desenganche/Filtrado';
import FormularComponen from '../../../components/Desenganche/Formulario';
import SolicitudesComponen from '../../../components/Desenganche/solicitudes';
import DesengancheFechaCorte from '../../../components/Desenganche/DesengancheFechaCorte';
import * as ROUTES from '../../../constans/rutas';

const HomePage = () => {
  const [ventana, setVentana] = useState(1);
  const [Terminales, setTerminales] = useState('');
  const [opcionesTerminales, setOpcionesTerminales] = useState([]);
  const history = useHistory();

  const terminales = async () => {
    try {
      const res = await axios.get(`${URL_EMPLOYEE}/desenganchadas/getParkTerminales`)
      const respuesta = res.data['res'].filter((terminal, index, self) =>
        !self.slice(index + 1).some((other) => other.nombre_park === terminal.nombre_park)
      );
      setTerminales(
        respuesta.map((terminal) => ({
          value: terminal.cod_park,
          label: terminal.nombre_park,
        }))
      );

    } catch (error) {
    }


  }
  useEffect(() => {
    terminales()

  }, []);
  useEffect(() => {
    console.log(Terminales);

  }, [Terminales]);


  return (

    <>
      <Container className="contendor-Principal">

        <Row>
          <Col className='cont_logo' xs={12} sm={12} md={12} lg={12} xl={12}>
            <img className='logo' src={logo}></img>

            <p className="texto-slogan">Sistema De Desenganche</p>
           
          </Col>

        </Row>
        <Row className="justify-content-end ">
          <Col style={{ display:'flex',justifyContent:'center',alignItems:'center',fontSize:'15px' }} className='cont_logo' xs={12} sm={12} md={6} lg={4} xl={4}>
            
            <Button style={{ marginRight: '10px' }} variant="primary" onClick={() => history.push(ROUTES.HOME)}>
            <FaHome size={20} style={{ marginRight: '5px' }} />HOME
            </Button>
          </Col>

        </Row>
        <Row className="justify-content-end mbottom-20 menu">
          <Col className={ventana === 1 ? "menu_items2" : "menu_items"} xs={2} sm={2} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(1) }}>Placa</button>
          </Col>
          <Col className={ventana === 2 ? "menu_items2" : "menu_items"} xs={4} sm={4} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(2) }}>Parqueadero</button>
          </Col>
          <Col className={ventana === 4 ? "menu_items2" : "menu_items"} xs={4} sm={4} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(4) }}>Por fecha</button>
          </Col>
          <Col className={ventana === 3 ? "menu_items2" : "menu_items"} xs={4} sm={4} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(3) }}>Solicitudes</button>
          </Col>
        </Row>
      </Container>
      <Container>
        {ventana === 1 ? (

          <FormularComponen Terminales={Terminales}></FormularComponen>
          // {Terminales}
        ) : null}
        {ventana === 2 ? (

          <BuscadorComponen Terminales={Terminales} ></BuscadorComponen>
          // {Terminales}
        ) : null}
        {ventana === 3 ? (

          <SolicitudesComponen></SolicitudesComponen>
          // {Terminales}
        ) : null}
        {ventana === 4 ? (
          <DesengancheFechaCorte Terminales={Terminales}></DesengancheFechaCorte>
        ) : null}
      </Container>

    </>
  )
}
export default HomePage;